/**
 * Build query-string params for the paginated REST endpoint.
 * SSE never uses these — its connection is filter-independent.
 */
export const buildRestParams = ({
  page,
  platform,
  status,
  objective,
  dateTimeRange,
  keyword,
  sourceType,
}) => {
  const p = new URLSearchParams();
  if (page) p.set("page", page);
  if (status != null) {
    String(status)
      .split(",")
      .forEach((s) => p.append("status", s.trim()));
  }
  if (platform) p.set("platform", platform);
  if (objective) p.set("type", objective);
  if (dateTimeRange) p.set("time_range", dateTimeRange);
  if (keyword) p.set("keyword", keyword);
  if (sourceType) p.set("sourceType", sourceType);
  return p.toString();
};

/**
 * Normalise raw docs from the API.
 * `keywords` comes back as an array; SessionCard expects a comma-joined string.
 */
export const normaliseDocs = (rawDocs) =>
  (Array.isArray(rawDocs) ? rawDocs : []).map((doc) => ({
    ...doc,
    keywords: Array.isArray(doc.keywords)
      ? doc.keywords.join(", ")
      : (doc.keywords ?? ""),
  }));
